import { SvgBase } from "../svg.base";

export const QualityUnlock = () => (
    <SvgBase
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <g fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
                <g>
                    <g>
                    <path d="M11.67 1.333c2.094.001 3.806 1.514 3.914 3.416l.006.192v2.226H14.52V4.94c0-1.45-1.277-2.625-2.852-2.625-1.518 0-2.758 1.086-2.851 2.459l-.006.166-.001 1.392H9.88c.755 0 1.376.508 1.447 1.157l.006.123v5.774c0 .707-.65 1.28-1.453 1.28H1.453c-.802 0-1.453-.573-1.453-1.28V7.613c0-.707.65-1.28 1.453-1.28h6.29V4.941c0-1.993 1.757-3.608 3.926-3.608zm-1.79 5.91H1.453c-.232 0-.42.166-.42.37v5.774c0 .204.188.37.42.37H9.88c.232 0 .42-.166.42-.37V7.613c0-.204-.188-.37-.42-.37zM5.73 9.667c.246 0 .45.157.493.364l.008.08v1.611c0 .246-.224.445-.5.445-.246 0-.45-.158-.492-.365l-.008-.08v-1.611c0-.245.224-.444.5-.444z" transform="translate(-733 -611) translate(600 608) translate(133) translate(0 3)"/>
                    </g>
                </g>
            </g>
        </g>
    </SvgBase>
);